// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__utCKb","icon":"tabs_icon__Z0uJL","Active-btn":"tabs_Active-btn__wDlHi","overlay":"tabs_overlay__bhjkH","showTabs":"tabs_showTabs__9EG+J"};